import { ApolloClient, InMemoryCache, concat } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { setContext } from "@apollo/client/link/context";
import { useAuthenticationStore } from "../stores/auth";

// Create a function to configure Apollo Client
const createApolloClient = () => {
  const authStore = useAuthenticationStore.getState();
  // Log any GraphQL errors or network error that occurred
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
        );
        if (message.includes("Signature has expired")) {
          authStore.logOutUser();
          window.location.href = "/auth/login";
        }
      });

    if (networkError?.statusCode === 403) {
      // Reload the page if access is denied, should redirect to somewhere to login
      window.reload();
    }
    if (networkError) {
      console.log(`[Network error]`, networkError);
    }
  });

  const isDevelopment =
    window.location.hostname === "localhost" ||
    window.location.hostname.includes("ngrok");

  const ngrokUrl = process.env.REACT_APP_NGROK_BACKEND_URL;

  const graphqlEndpoint = isDevelopment
    ? window.location.hostname.includes("ngrok")
      ? `${ngrokUrl}/graphql`
      : "http://localhost:5000/graphql"
    : `/graphql`;

  const authLink = setContext((operation, { headers }) => {
    const { user } = useAuthenticationStore.getState();
    const token = user.token;

    // NOTE: when doing refreshToken - if we include the JTW token itself in the header it
    //  checks it and then says its expired throwing an error. So when doing this operation, exclude from header
    const isRefreshRequest = operation.operationName === "refreshToken";
    return {
      headers: {
        ...headers,
        authorization: isRefreshRequest ? "" : token ? `JWT ${token}` : "",
      },
    };
  });

  const uploadLink = createUploadLink({
    uri: graphqlEndpoint,
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: concat(authLink, concat(errorLink, uploadLink)),
  });

  return client;
};

export default createApolloClient;
